
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5XZ0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4581c8edd4dd7cfd$export$2e2bcd8739ae039; });

var $krmhT = parcelRequire("krmhT");

var $dFETA = parcelRequire("dFETA");

var $3HURB = parcelRequire("3HURB");

const $4581c8edd4dd7cfd$var$Header = (props)=>{
    const storedData = JSON.parse(localStorage.getItem("wfm:body_form") ?? JSON.stringify({
        ...(0, $dFETA.BODY_SCHEMA)
    }));
    const isReady = storedData.email.length > 0;
    (0, $krmhT.default)(()=>{
        const fixedHeader = (0, $3HURB.default)("#fixed-header");
        document.addEventListener("scroll", ()=>{
            const scrollTop = window.scrollY;
            if (scrollTop >= 100) fixedHeader.setAttribute("data-open", "true");
            else fixedHeader.setAttribute("data-open", "false");
        });
        const modal = (0, $3HURB.default)(".nav-modal"), openModal = document.querySelectorAll(".burger-menu"), closeModal = (0, $3HURB.default)(".close-modal"), links = document.querySelectorAll(".nav-modal nav ul li a");
        closeModal.onclick = ()=>modal.style.display = "none";
        openModal.forEach((btn)=>{
            btn.addEventListener("click", ()=>modal.style.display = "flex");
        });
        links.forEach((link)=>link.addEventListener("click", ()=>modal.style.display = "none"));
        // redirect to bottom of page
        const contactButtons = document.querySelectorAll(".contact-button");
        contactButtons.forEach((el)=>el.addEventListener("click", ()=>window.scrollTo(0, 9999)));
    });
    return /*html*/ `
	<header class="global__header">
		<nav>
			<ul>
				<li><a href="/#projects">Proyectos</a></li>
				<!-- <li><a href="/#oportunities">Oportunidades</a></li>	  -->
				<li>\u{25A0}</li>	
				<li><a href="/aboutus">Nosotros</a></li>	 
			</ul>
		</nav>

		<button class="burger-menu" type="button">
			<img src="/vector/burger-light.svg" width="26" height="auto" alt="burger" />
		</button>
			
		<a href="/">
			<img src="/vector/wfm-logo.svg" width="120" height="auto" alt="logo" />
		</a>

		<div class="buttons__wrapper">
			${props?.brochure ? /*html*/ `
				<div class="form__wrapper__download">
				<button type="button" class="download_brochure_button" data-order="1" data-disable="${isReady}" data-ready="false">
					Brochure
					<img src="/vector/download.svg" alt="download" width="22" height="22" />
				</button>
				<a href="${props?.brochure}" id="download_brochure_link" download hidden></a>
				
				<form id="download_brochure_form" class="bubble__form brochure_1" aria-expanded="false">
					<strong>Complet\xe1 el formulario para conocer m\xe1s sobre el proyecto</strong>
	
					<!-- <div role="name">
						<label for="name">Nombre</label>
						<input type="text" id="name" name="name" placeholder="John" />
					</div>
					<div role="lastname">
						<label for="lastname">Apellido</label>
						<input type="text" id="lastname" name="lastname" placeholder="Smith" />
					</div> -->
					<div role="email">
						<label for="email">Correo</label>
						<input type="email" id="email" name="email" placeholder="tu@dominio.com" />
					</div>
					<!-- <div role="phone">
						<label for="phone">Celular</label>
						<div>
							<p>+54</p>
							<span></span>
							<input type="text" id="phone" name="phone" placeholder="11 1234 1234" />
						</div>
					</div> -->
				</form>
				</div>
				` : ""}
			
			<button class="contact-button" type="button">
				<p>Contactar</p>
				<img src="/vector/email-black.svg" width="22" height="22" alt="Contactar" />
			</button>
		</div>
	</header>

	<header class="global__fixed__header" data-open="false" id="fixed-header">
		<nav>
			<ul>
				<li><a href="/#projects">Proyectos</a></li>
				<!-- <li><a href="/#oportunities">Oportunidades</a></li>	  -->
				<li>\u{25A0}</li>	
				<li><a href="/aboutus">Nosotros</a></li>	 
			</ul>
		</nav>

		<button type="button" class="burger-menu">
			<img src="/vector/burger-dark.svg" width="26" height="auto" alt="burger" />
		</button>
			
		<a href="/">
			<img src="/vector/wfm-logo-black.svg" width="120" height="auto" alt="logo" />
		</a>

		<div class="buttons__wrapper">
		${props?.brochure ? /*html*/ `
				<div class="form__wrapper__download">
				<button type="button" class="download_brochure_button redirect_brochure">
					Brochure
					<img src="/vector/download.svg" alt="download" width="22" height="22" />
				</button>
				</div>
				` : ""}
			<button class="contact-button" type="button">
				<p>Contactar</p>
				<img src="/vector/email-white.svg" width="22" height="22" alt="Contactar" />
			</button>
		</div>
	</header>
	
	<div class="nav-modal" style="display: none;">
		<button type="button" class="close-modal">
			<img src="/vector/times.svg" width="26" height="auto" alt="close-modal" />
		</button>
		<nav>
			<ul>
				<li><a href="/#projects">Proyectos</a></li>
				<!-- <li><a href="/#oportunities">Oportunidades</a></li> -->
				<li><a href="/aboutus">Nosotros</a></li>
			</ul>
		</nav>
	</div>`;
};
var $4581c8edd4dd7cfd$export$2e2bcd8739ae039 = $4581c8edd4dd7cfd$var$Header;

});
parcelRegister("krmhT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee179e1a996dd96c$export$2e2bcd8739ae039; });
function $ee179e1a996dd96c$var$onceMounted(callback) {
    // is trash i know
    setTimeout(()=>{
        callback();
    }, 50);
}
var $ee179e1a996dd96c$export$2e2bcd8739ae039 = $ee179e1a996dd96c$var$onceMounted;

});

parcelRegister("dFETA", function(module, exports) {

$parcel$export(module.exports, "BODY_SCHEMA", function () { return $9f3ed3b976261fba$export$2b3a68d2765a4c50; });
const $9f3ed3b976261fba$export$2b3a68d2765a4c50 = {
    phone: "",
    name: "",
    email: "",
    lastname: "",
    message: ""
};

});

parcelRegister("3HURB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b317f2e692417e5$export$2e2bcd8739ae039; });
/** @type {(selector: string) => HTMLElement} */ const $2b317f2e692417e5$var$$ = (selector)=>document.querySelector(selector);
var $2b317f2e692417e5$export$2e2bcd8739ae039 = $2b317f2e692417e5$var$$;

});


parcelRegister("4V5vL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3950c2b72fdb82c8$export$2e2bcd8739ae039; });

var $dFETA = parcelRequire("dFETA");
const $3950c2b72fdb82c8$var$useContactForm = (defaultTemplate = "")=>{
    let mailto = "mailto:";
    let body = {
        phone: "",
        name: "",
        email: "",
        lastname: "",
        message: ""
    };
    const params = {
        cc: "",
        subject: "",
        body: "",
        to: "info@wfm.com.ar"
    };
    const update = (key, value)=>{
        switch(key){
            case "email":
                params.cc = value;
                break;
            case "name":
                body.name = value;
                break;
            case "lastname":
                body.lastname = value;
                break;
            case "phone":
                body.phone = value;
                break;
            case "message":
                body.message = value;
                break;
        }
        const { message: message, ...localBody } = body;
        localStorage.setItem("wfm:body_form", JSON.stringify({
            ...localBody,
            email: params.cc
        }));
    };
    const getLink = ()=>{
        params.subject = "WFM Investments | Contacto";
        params.body = encodeURIComponent(`${defaultTemplate}Nombre: ${body.name}\nApellido: ${body.lastname}\nCelular: ${body.phone}\n---\n${body.message}`);
        return `${mailto}${params.to}?${Object.keys(params).map((key)=>`${key}=${params[key]}`).join("&")}`;
    };
    const submit = (e)=>{
        e.preventDefault();
        window.open(getLink(), "_blank");
    };
    const getData = ()=>{
        const storedData = JSON.parse(localStorage.getItem("wfm:body_form") ?? "{}");
        return {
            ...body,
            ...params,
            ...storedData
        };
    };
    const isReady = ()=>{
        const storedData = JSON.parse(localStorage.getItem("wfm:body_form") || JSON.stringify((0, $dFETA.BODY_SCHEMA)));
        return storedData.email.length > 0;
    };
    return {
        update: update,
        submit: submit,
        getData: getData,
        isReady: isReady
    };
};
var $3950c2b72fdb82c8$export$2e2bcd8739ae039 = $3950c2b72fdb82c8$var$useContactForm;

});

parcelRegister("2ZOWM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22e8cc4a344e72d8$export$2e2bcd8739ae039; });

var $krmhT = parcelRequire("krmhT");

var $4V5vL = parcelRequire("4V5vL");

var $3HURB = parcelRequire("3HURB");

const $22e8cc4a344e72d8$var$Footer = ()=>{
    const { update: update, submit: submit } = (0, $4V5vL.default)();
    (0, $krmhT.default)(()=>{
        const form = (0, $3HURB.default)("#contact-form"), inputs = form.querySelectorAll("input, textarea");
        inputs.forEach((input)=>{
            input.addEventListener("input", (e)=>{
                update(e.target.name, e.target.value);
            });
        });
        form.addEventListener("submit", submit);
    });
    return /*html*/ `
	<footer class="global__footer">
		<section class="footer__wrapper">
			<section class="footer__top">
				<h2>Conectamos para construir el futuro</h2>
	
				<div class="footer__list">
					<h6>Navegaci\xf3n r\xe1pida</h6>
					<ul>
						<li><a href="/voir/suites">Voir Suites</a></li>
						<li><a href="/voir/amenabar">Voir Amen\xe1bar</a></li>
						<li><a href="/voir/palpa">Voir Palpa</a></li>
						<li><a href="/voir/cespedes">Live Voir C\xe9spedes</a></li>
					</ul>
				</div>

				<div class="row">
					<a href="https://api.whatsapp.com/send?phone=5491149705025" target="_blank" role="button">
						<img src="/vector/whatsapp.svg" alt="whatsapp" />
					</a>
					<a href="https://www.instagram.com/wfm.investments/" target="_blank" role="button">
						<img src="/vector/instagram.svg" alt="instagram" />
					</a>
					<a href="https://www.facebook.com/WFMinvestments" target="_blank" role="button">
						<img src="/vector/facebook.svg" alt="facebook" />
					</a>
				</div>
			</section>
	
			<section class="footer__middle">
				<div class="footer__list">
					<ul>
						<li>
							<img src="/vector/location.svg" alt="location" />
							<a href="https://www.google.com.ar/maps/place/Av.+del+Libertador+264,+B1638+Vicente+L%C3%B3pez,+Provincia+de+Buenos+Aires/@-34.532023,-58.4689734,17z/data=!4m16!1m9!3m8!1s0x95bcb6af4f087d41:0xce0e216d324219d7!2sAv.+del+Libertador+264,+B1638+Vicente+L%C3%B3pez,+Provincia+de+Buenos+Aires!3b1!8m2!3d-34.5321057!4d-58.4693111!10e5!16s%2Fg%2F11r_gt5bzv!3m5!1s0x95bcb6af4f087d41:0xce0e216d324219d7!8m2!3d-34.5321057!4d-58.4693111!16s%2Fg%2F11r_gt5bzv?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank">
								Libertador 7766, 4to-06, Nu\xf1ez, CABA.
							</a>
						</li>
						<li>
							<img src="/vector/cellphone.svg" alt="cellphone" />
							<a href="tel:+5491149705025">+54 9 11 4970 5025</a>
						</li>
						<li role="email">
							<img src="/vector/email.svg" alt="email" />
							<a href="mailto:info@wfm.com.ar">info@wfm.com.ar</a>
						</li>
					</ul>
				</div>
	
				<form id="contact-form">
					<div role="name">
						<label for="name">Nombre</label>
						<input type="text" id="name" name="name" placeholder="John" />
					</div>
					<div role="lastname">
						<label for="lastname">Apellido</label>
						<input type="text" id="lastname" name="lastname" placeholder="Smith" />
					</div>
					<div role="email">
						<label for="email">Correo</label>
						<input type="email" id="email" name="email" placeholder="tu@dominio.com" />
					</div>
					<div role="phone">
						<label for="phone">Celular</label>
						<div>
							<p>+54</p>
							<span></span>
							<input type="text" id="phone" name="phone" placeholder="11 1234 1234" />
						</div>
					</div>
					<div role="message">
						<label for="message">Mensaje</label>
						<textarea id="message" name="message" rows="5" placeholder="Deja tu mensaje..."></textarea>
					</div>
					<button type="submit">Contactar</button>
				</form>
			</section>
		</section>

		<section class="footer__bottom">
			<a href="/">
				<img src="/vector/wfm-logo.svg" alt="WFM Investments" width="auto" height="25" />
			</a> 
			<p>2025 \xa9 WFM Investments</p>
		</section>
	</footer>`;
};
var $22e8cc4a344e72d8$export$2e2bcd8739ae039 = $22e8cc4a344e72d8$var$Footer;

});


var $5XZ0q = parcelRequire("5XZ0q");

const $7c4dd94e3f15ba4a$var$LandingPage = ()=>{
    return /*html*/ `
	<section class="landing__page" style="background-image: url('/pics/landing-page.jpg?quality=50');">
		<span>
			<h1>Espacios \xfanicos<br/>
			<i>dise\xf1ados para vos.</i></h1>
		</span>

		<div class="landing__page_sroll_down">
			<button type="button" id="go-to-projects">
				<div class="spiral-wrapper">
				<img id="spiral" src="/pics/spiral-projects.webp" alt="spiral-projects" />
				<img class="arrow-down" src="/vector/arrow-down.svg" alt="arrow-down" />
				</div>
			</button>
		</div>

		<a href="https://api.whatsapp.com/send?phone=5491149705025" target="_blank" role="whatsapp">
			<img src="/vector/whatsapp.svg" alt="whatsapp" width="23" height="23" />
		</a>

		<!-- <img class="noise_texture" src="/textures/noise.png" /> -->
	</section>`;
};
var $7c4dd94e3f15ba4a$export$2e2bcd8739ae039 = $7c4dd94e3f15ba4a$var$LandingPage;



var $6JLEh = parcelRequire("6JLEh");

var $krmhT = parcelRequire("krmhT");

var $4V5vL = parcelRequire("4V5vL");

var $3HURB = parcelRequire("3HURB");

const $d3cd364b6c53b3ed$var$OportunitiesGrid = ()=>{
    const { update: updateMailInfinity, getData: getDataMailInfinity, isReady: isReadyInfinity } = (0, $4V5vL.default)();
    const { update: updateMailDome, getData: getDataMailDome, isReady: isReadyDome } = (0, $4V5vL.default)();
    (0, $krmhT.default)(()=>{
        const downloadInfinity = (0, $3HURB.default)("#download_infinity"), bubbleFormInfinity = (0, $3HURB.default)(".bubble__form__infinity");
        const allInputsInfinity = bubbleFormInfinity.querySelectorAll("input, textarea");
        const isValidInfinity = ()=>Array.from(allInputsInfinity).every((input)=>input.value.length > 0);
        allInputsInfinity.forEach((input)=>{
            input.addEventListener("input", (e)=>{
                downloadInfinity.setAttribute("data-ready", String(isValidInfinity()));
            });
        });
        // brochure form infinity
        const formBrochureInfinity = (0, $3HURB.default)("#download_brochure_form[data-type='infinity']"), inputsBrochureInfinity = formBrochureInfinity.querySelectorAll("input, textarea");
        inputsBrochureInfinity.forEach((input)=>{
            input.addEventListener("input", (e)=>{
                updateMailInfinity(e.target.name, e.target.value);
            });
        });
        downloadInfinity.onclick = (ev)=>{
            ev.preventDefault();
            ev.stopPropagation();
            ev.stopImmediatePropagation();
            if (isReadyInfinity()) {
                const { name: name, lastname: lastname, cc: cc, email: email, phone: phone } = getDataMailInfinity();
                (0, $6JLEh.Mail).send({
                    email: cc || email,
                    name: `${email}`,
                    subject: `Descarga de brochure | ${email}`,
                    body: `Correo: ${email}
---
Descarg\xf3 brochure Infinity`
                }).catch(console.error);
                (0, $3HURB.default)("#link_infinity").click();
                // Reset
                setTimeout(()=>{
                    allInputsInfinity.forEach((input)=>input.value = "");
                    bubbleFormInfinity.setAttribute("aria-expanded", String(false));
                    downloadInfinity.setAttribute("data-ready", String(false));
                }, 250);
                return;
            }
            const expanded = bubbleFormInfinity.getAttribute("aria-expanded") === "false";
            bubbleFormInfinity.setAttribute("aria-expanded", String(expanded));
        };
        const downloadDome = (0, $3HURB.default)("#download_dome"), bubbleFormDome = (0, $3HURB.default)(".bubble__form__dome");
        const allInputsDome = bubbleFormDome.querySelectorAll("input, textarea");
        const isValidDome = ()=>Array.from(allInputsDome).every((input)=>input.value.length > 0);
        allInputsDome.forEach((input)=>{
            input.addEventListener("input", (e)=>{
                downloadDome.setAttribute("data-ready", String(isValidDome()));
            });
        });
        // brochure form dome
        const formBrochureDome = (0, $3HURB.default)("#download_brochure_form[data-type='dome']"), inputsBrochureDome = formBrochureDome.querySelectorAll("input, textarea");
        inputsBrochureDome.forEach((input)=>{
            input.addEventListener("input", (e)=>{
                updateMailDome(e.target.name, e.target.value);
            });
        });
        downloadDome.onclick = (ev)=>{
            ev.preventDefault();
            ev.stopPropagation();
            ev.stopImmediatePropagation();
            if (isReadyDome()) {
                const { name: name, lastname: lastname, cc: cc, email: email, phone: phone } = getDataMailDome();
                (0, $6JLEh.Mail).send({
                    email: cc || email,
                    name: `${email}`,
                    subject: `Descarga de brochure | ${email}`,
                    body: `Correo: ${email}
---
Descarg\xf3 brochure Dome`
                }).catch(console.error);
                (0, $3HURB.default)("#link_dome").click();
                // Reset
                setTimeout(()=>{
                    allInputsDome.forEach((input)=>input.value = "");
                    bubbleFormDome.setAttribute("aria-expanded", String(false));
                    downloadDome.setAttribute("data-ready", String(false));
                }, 250);
                return;
            }
            const expanded = bubbleFormDome.getAttribute("aria-expanded") === "false";
            bubbleFormDome.setAttribute("aria-expanded", String(expanded));
        };
    });
    return /*html*/ `
	<section class="oportunities__grid">
		<div class="oportunities__header">
			<h6 id="oportunities">Tambi\xe9n somos parte</h6>
      <p>En WFM colaboramos con constructoras como ADN y Grupo Portland, desarrollando proyectos en las zonas m\xe1s prometedoras de Buenos Aires. S\xe9 parte de esta oportunidad e invert\xed en edificios \xfanicos con alta proyecci\xf3n de valor.</p>
			<div role="spacer"></div>
		</div>

		<div class="grid__container">
			<article>
				<figure>
					<img
						src="/pics/oportunity_infinity.jpg"
						width="800"
						height="800"
						alt="Infity Towers"
					/>
					<figcaption>
            <p>Entrega Inmediata</p>
					</figcaption>
				</figure>

				<div class="form__wrapper__download">
					<button type="button" id="download_infinity" data-disable="${isReadyInfinity()}" data-ready="false">
						Brochure
						<img src="/vector/download.svg" alt="download" width="22" height="22" />
					</button>
					<a href="/dowloads/INFINITY_TOWERS.pdf" id="link_infinity" download hidden></a>
				
					<form id="download_brochure_form" data-type="infinity" class="bubble__form__infinity" aria-expanded="false">
						<strong>Complet\xe1 el formulario para conocer m\xe1s sobre el proyecto</strong>

						<!-- <div role="name">
							<label for="name">Nombre</label>
							<input type="text" id="name" name="name" placeholder="John" />
						</div>
						<div role="lastname">
							<label for="lastname">Apellido</label>
							<input type="text" id="lastname" name="lastname" placeholder="Smith" />
						</div> -->
						<div role="email">
							<label for="email">Correo</label>
							<input type="email" id="email" name="email" placeholder="tu@dominio.com" />
						</div>
						<!-- <div role="phone">
							<label for="phone">Celular</label>
							<div>
								<p>+54</p>
								<span></span>
								<input type="text" id="phone" name="phone" placeholder="11 1234 1234" />
							</div>
						</div> -->
					</form>
				</div>
			</article>

			<article aria-disabled="true">
				<figure>
					<img
						src="/pics/oportunity_dome.jpg"
						width="800"
						height="800"
						alt="Dome Apartments"
					/>
					<figcaption>
						<p>Entrega 2029</p>
					</figcaption>
				</figure>

				<div class="form__wrapper__download">
					<button type="button" id="download_dome" data-disable="${isReadyDome()}" data-ready="false">
						Brochure
						<img src="/vector/download.svg" alt="download" width="22" height="22" />
					</button>
					<a href="/dowloads/Dome Torre Arcos - WFM .pdf" id="link_dome" download hidden></a>
				
					<form id="download_brochure_form" data-type="dome" class="bubble__form__dome" aria-expanded="false">
						<strong>Complet\xe1 el formulario para conocer m\xe1s sobre el proyecto</strong>

						<!-- <div role="name">
							<label for="name">Nombre</label>
							<input type="text" id="name" name="name" placeholder="John" />
						</div>
						<div role="lastname">
							<label for="lastname">Apellido</label>
							<input type="text" id="lastname" name="lastname" placeholder="Smith" />
						</div> -->
						<div role="email">
							<label for="email">Correo</label>
							<input type="email" id="email" name="email" placeholder="tu@dominio.com" />
						</div>
						<!-- <div role="phone">
							<label for="phone">Celular</label>
							<div>
								<p>+54</p>
								<span></span>
								<input type="text" id="phone" name="phone" placeholder="11 1234 1234" />
							</div>
						</div> -->
					</form>
				</div>
			</article>
		</div>
	</section>
	`;
};
var $d3cd364b6c53b3ed$export$2e2bcd8739ae039 = $d3cd364b6c53b3ed$var$OportunitiesGrid;



const $9f8dab0377287d6e$var$ProjectsCarousel = ()=>{
    // Activar scroll horizontal con drag y prevenir clics si hubo movimiento
    requestAnimationFrame(()=>{
        const wrapper = document.querySelector(".carousel__wrapper");
        if (!wrapper) return;
        let isDragging = false;
        let startX;
        let scrollLeft;
        let moved = false;
        const links = wrapper.querySelectorAll("a");
        wrapper.addEventListener("mousedown", (e)=>{
            isDragging = true;
            moved = false;
            wrapper.classList.add("dragging");
            startX = e.pageX - wrapper.offsetLeft;
            scrollLeft = wrapper.scrollLeft;
        });
        wrapper.addEventListener("mousemove", (e)=>{
            if (!isDragging) return;
            e.preventDefault();
            const x = e.pageX - wrapper.offsetLeft;
            const walk = x - startX;
            if (Math.abs(walk) > 5) moved = true;
            wrapper.scrollLeft = scrollLeft - walk;
        });
        wrapper.addEventListener("mouseup", ()=>{
            isDragging = false;
            wrapper.classList.remove("dragging");
        });
        wrapper.addEventListener("mouseleave", ()=>{
            isDragging = false;
            wrapper.classList.remove("dragging");
        });
        // Prevenir el click si hubo arrastre
        links.forEach((link)=>{
            link.addEventListener("click", (e)=>{
                if (moved) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            });
        });
    });
    return /*html*/ `
    <section class="projects__carousel">
      <div class="carousel__header">
        <h6 id="projects">Encontr\xe1 tu proyecto ideal</h6>
      </div>
      <div class="carousel__container">
        <div class="carousel__wrapper">
          <div class="carousel">
            <a href="/voir/suites" draggable="false">
              <figure>
                <img src="/pics/suites/Edificio Dia.webp" width="480" height="720" alt="Suites" draggable="false"/>
                <figcaption>
                  <span>
                    <img src="/vector/VOIR.logo.svg" alt="VOIR" draggable="false" draggable="false"/>
                    <p>Suites</p>
                  </span>
                  <span><b>Entrega 2027</b></span>
                </figcaption>
              </figure>
            </a>

            <a href="/voir/cespedes" draggable="false">
              <figure>
                <img src="/pics/voir_cespedes.webp" width="480" height="720" alt="C\xe9spedes" draggable="false"/>
                <figcaption>
                  <span>
                    <img src="/pics/LOGO LIVE.webp" width="45" alt="live" draggable="false"/>
                    <img src="/vector/VOIR.logo.svg" alt="VOIR" draggable="false"/>
                    <p>C\xe9spedes</p>
                  </span>
                  <span><b>Entrega 2028</b></span>
                </figcaption>
              </figure>
            </a>

            <a href="/voir/amenabar" draggable="false">
              <figure>
                <img src="/pics/voir_amenabar.webp" width="480" height="720" alt="Amen\xe1bar" draggable="false"/>
                <figcaption>
                  <span>
                    <img src="/vector/VOIR.logo.svg" alt="VOIR" draggable="false"/>
                    <p>Amen\xe1bar</p>
                  </span>
                  <span><b>Entrega inmediata</b></span>
                </figcaption>
              </figure>
            </a>

            <a href="/voir/palpa" draggable="false">
              <figure>
                <img src="/pics/voir_palpa.webp" width="480" height="720" alt="Palpa" draggable="false"/>
                <figcaption>
                  <span>
                    <img src="/vector/VOIR.logo.svg" alt="VOIR" draggable="false"/>
                    <p>Palpa</p>
                  </span>
                  <span><b>Vendido</b></span>
                </figcaption>
              </figure>
            </a>

          </div>
        </div>
      </div>
    </section>
  `;
};
var $9f8dab0377287d6e$export$2e2bcd8739ae039 = $9f8dab0377287d6e$var$ProjectsCarousel;



var $2ZOWM = parcelRequire("2ZOWM");


document.getElementById("root").innerHTML = /*html*/ `
	${(0, $5XZ0q.default)()}
	${(0, $7c4dd94e3f15ba4a$export$2e2bcd8739ae039)()}
	${(0, $9f8dab0377287d6e$export$2e2bcd8739ae039)()}
	${(0, $d3cd364b6c53b3ed$export$2e2bcd8739ae039)()}
	${(0, $2ZOWM.default)()}
`;


//# sourceMappingURL=index.378ba4c5.js.map
